import FormHelpers from './util/form';
import { cookieExists, createCookie } from './util/common';

class Newsletter {
    constructor () {
        this.newsletter = 'form.newsletter';
    }

    newsletterForm () {
        lock();

        $('body').on('change', '[name="mrmrs"]:not(#mrmrs)', (e) => {
            let selectedOption = document.querySelector('.gender-checked');
            if (selectedOption) {
                selectedOption.querySelector('.mrmrs-option').checked = false;
                selectedOption.classList.remove('gender-checked');
            }
            e.currentTarget.checked = true;
            e.currentTarget.parentNode.classList.add('gender-checked');
        });

        $('body').on('change', '[name="newspromotionsPlaceholder"]', () => {
            if ($('#newspromotionsPlaceholder').is(':checked')) {
                document.getElementById('newspromotions').checked = true;
                document.getElementById('newspromotions1').checked = false;
                unlock();
                document.getElementById('newspromotions_targeted1').checked = true;
                document.getElementById('newspromotions_targeted').checked = false;
            } else {
                document.getElementById('newspromotions1').checked = true;
                document.getElementById('newspromotions').checked = false;
                if ($('#newspromotionsTargetedPlaceholder').is(':checked')) {
                    document.getElementById('newspromotionsTargetedPlaceholder').checked = false;
                }
                lock();
            }
        });

        $('body').on('change', '[name="newspromotionsTargetedPlaceholder"]', () => {
            if ($('#newspromotionsTargetedPlaceholder').is(':checked')) {
                document.getElementById('newspromotions_targeted').checked = true;
                document.getElementById('newspromotions_targeted1').checked = false;
            } else {
                document.getElementById('newspromotions_targeted1').checked = true;
                document.getElementById('newspromotions_targeted').checked = false;
            }
        });

        $('body').on('change', '[name="newspromotions"]', () => {
            if ($('#newspromotions').is(':checked')) {
                unlock();
            } else {
                lock();
            }
        });

        $('body').on('change', '[name="newspromotions"], [name="newspromotions_targeted"]', (e) => {
            $(e.currentTarget).val($(e.currentTarget).is(':checked'));
        });

        function lock () {
            if (!$('.lockable').hasClass('content-lock')) {
                $('.lockable').addClass('content-lock');
            }
            $('.lockable label input').attr('disabled', true);

            $('#newspromotions_targeted, #newspromotions_targeted1').prop('checked', false);
        }

        function unlock () {
            $('.content-lock').removeClass('content-lock');
            $('.lockable label input').attr('disabled', false);
        }

        $('body').on('submit', 'form.newsletter, form.registerNewsletter', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            var isNewsletterNew = $('.page').data('action') === 'Newsletter-ShowNew';
            $.spinner().start();
            $('form.newsletter').trigger('newsletter:submit', e);
            let dataToSend = $form.serialize();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: dataToSend,
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init($form, data);
                        $('form.newsletter').trigger('newsletter:error', data);
                    } else {
                        if ((isNewsletterNew && $('#newspromotionsPlaceholder').length > 0 && $('#newspromotionsPlaceholder').is(':checked')) ||
                            (!isNewsletterNew && $('input[name="newspromotions"]:checked').length > 0)) {
                            $('body').trigger('newsletter:subscribeWithSuccess');
                        }
                        createCookie('dw_subscribepopup', '1', parseInt(window.SitePreferences.NewsletterPopupExpiryDays));
                        $('form.newsletter').trigger('newsletter:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.newsletter').trigger('newsletter:error', data);
                        $form.spinner().stop();
                    }
                }
            });
            return false;
        });
        $('body').on('click', '.edit-info', () => {
            if ($('.registrationFormStepOne').hasClass('hidden')) {
                $('.registrationFormStepTwo').addClass('hidden');
                $('.registrationFormStepOne').removeClass('hidden');
            }
        });
    };
}

const newsletter = new Newsletter();
export default newsletter;

document.addEventListener('DOMContentLoaded', () => {
    newsletter.newsletterForm();
});
